import api from '../../config/axios.js';

let receivedRequestId = 0;
let expenseRequestId = 0;
let cardsRequestId = 0;
const emptyPagination = () => ({ current_page: 1, last_page: 1, per_page: 10, total: 0 });
const emptyCards = () => ({ amount_received: '0,00', tax: '0,00', amount_expense: '0,00', qtd_expense: 0, qtd_schedules: 0 });

const state = {
    financialData: [],
    financialPagination: emptyPagination(),
    financialQuery: { month: null, year: null },
    expenseData: [],
    currentExpense: {},
    currentDeleteExpense: {},
    cardsFinancialManagementData: emptyCards(),
};
const getters = {
    getFinancialData: state => state.financialData,
    getFinancialPagination: state => state.financialPagination,
    getFinancialQuery: state => state.financialQuery,
    getExpenseData: state => state.expenseData,
    getCurrentExpense: state => state.currentExpense,
    getCurrentDeleteExpense: state => state.currentDeleteExpense,
    getCardsFinancialManagementData: state => state.cardsFinancialManagementData,
};
const actions = {
    async refreshFinancialManagement({ state, commit, dispatch }, params = {}) {
        const query = {
            month: params.month === undefined ? state.financialQuery.month : params.month,
            year: params.year === undefined ? state.financialQuery.year : params.year,
        };
        const page = params.page ?? state.financialPagination.current_page;
        if (query.month !== state.financialQuery.month || query.year !== state.financialQuery.year) {
            commit('resetVisibleFinancial');
        }
        commit('setFinancialQuery', query);
        await Promise.all([
            dispatch('fetchFinancialData', { ...query, page }),
            dispatch('fetchExpenseData', query),
            dispatch('fetchCardsFinancialManagementData', query),
        ]);
    },
    async fetchFinancialData({ commit }, params = {}) {
        const month = params?.month ?? null;
        const year = params?.year ?? null;
        const page = params?.page ?? 1;
        const requestId = ++receivedRequestId;
        commit('setFinancialQuery', { month, year });
        try {
            const { data } = await api.axios.get(`/api/financial/received/${month}/${year}?page=${page}`);
            if (requestId !== receivedRequestId) return;
            const list = Array.isArray(data.data) ? data.data : data;
            commit('fetchFinancialData', list);
            commit('setFinancialPagination', Array.isArray(data.data) ? {
                current_page: data.current_page ?? page,
                last_page: data.last_page ?? 1,
                per_page: data.per_page ?? 10,
                total: data.total ?? list.length,
            } : { current_page: 1, last_page: 1, per_page: list.length, total: list.length });
        } catch (error) {
            if (requestId !== receivedRequestId) return;
            commit('fetchFinancialData', []);
            commit('setFinancialPagination', emptyPagination());
        }
    },
    async fetchExpenseData({ commit }, params) {
        const requestId = ++expenseRequestId;
        try {
            const { data } = await api.axios.get(`/api/financial/expense/${params?.month ?? null}/${params?.year ?? null}`);
            if (requestId === expenseRequestId) commit('fetchExpenseData', data);
        } catch (error) {
            if (requestId === expenseRequestId) commit('fetchExpenseData', []);
        }
    },
    async fetchCardsFinancialManagementData({ commit }, params) {
        const requestId = ++cardsRequestId;
        try {
            const { data } = await api.axios.get(`/api/financial/metrics/${params?.month ?? null}/${params?.year ?? null}`);
            if (requestId === cardsRequestId) commit('fetchCardsFinancialManagementData', data);
        } catch (error) {
            if (requestId === cardsRequestId) commit('fetchCardsFinancialManagementData', emptyCards());
        }
    },
    setCurrentExpense({ commit }, expense) { commit('setCurrentExpense', expense); },
    setCurrentDeleteExpense({ commit }, expense) { commit('setCurrentDeleteExpense', expense); },
};
const mutations = {
    resetVisibleFinancial(state) {
        ++receivedRequestId; ++expenseRequestId; ++cardsRequestId;
        state.financialData = [];
        state.financialPagination = emptyPagination();
        state.cardsFinancialManagementData = emptyCards();
        state.expenseData = [];
    },
    fetchFinancialData(state, data) { state.financialData = data; },
    setFinancialPagination(state, data) { state.financialPagination = data; },
    setFinancialQuery(state, data) {
        state.financialQuery = { month: data?.month ?? null, year: data?.year ?? null };
    },
    fetchExpenseData(state, data) { state.expenseData = data; },
    fetchCardsFinancialManagementData(state, data) { state.cardsFinancialManagementData = data; },
    setCurrentExpense(state, data) { state.currentExpense = data; },
    setCurrentDeleteExpense(state, data) { state.currentDeleteExpense = data; },
};
export default { state, getters, actions, mutations };
